import React from 'react';
import moment from 'moment';
import classnames from 'classnames';

export default class CalendarTime extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onTimeClick = this.onTimeClick.bind(this);
    }

    onTimeClick(e) {
        if(e.stopPropagation)
            e.stopPropagation();
        e.preventDefault();
        
        this.props.onTimeClick(e);
    }

    render() {
        const interval = this.props.interval;
        const timeclass = ['time'];
        if(this.props.value && this.props.value.isSame(moment(interval.cmbDelayedIntervalId))) {
            timeclass.push('selected');
        }
        return (
            <li 
                key={'LI'+interval.cmbDelayedIntervalHour} 
                className={classnames(timeclass)} 
                role="option"
                onClick={this.onTimeClick}
                data-value={interval.cmbDelayedIntervalId}>
                {interval.cmbDelayedIntervalHour.split('-')[0]}
            </li>
        );
    }
}
